module.exports = __webpack_public_path__ + "img/1..80b5c3f9.jpg";